import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-myAddressCheckedRadio",
  "use": "icon-myAddressCheckedRadio-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-myAddressCheckedRadio\">\n<circle cx=\"13.25\" cy=\"13.25\" r=\"10\" fill=\"black\" />\n<circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"#FFCF00\" />\n<circle cx=\"12\" cy=\"12\" r=\"4\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol